import { atom } from 'recoil'

export const chatWindowState = atom({
  key: 'chatWindowState',
  default: {
    window: null,
  },
  dangerouslyAllowMutability: true,
})
